export const formatCurrency = (value, currency) => {
  // Convert string values to numbers and handle decimal values
  const numericValue = typeof value === 'string' 
    ? parseFloat(value) * 100 
    : value;

  const normalizedValue = numericValue / 100;
  // if (window.Shopify.currency.active !== 'USD') {
  //   value = value * window.Shopify.currency.rate;
  // }
  return normalizedValue.toLocaleString('en-US', {
    style: 'currency',
    currency: currency || window.Shopify?.currency.active || 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
